import { Component, Input, OnDestroy } from '@angular/core';
import { MessengerService } from '../../../../services/messenger/messenger.service';
import { IntervalService } from '../../../../services/interval/interval.service';

@Component({
  selector: 'default-launcher-header',
  templateUrl: './default-launcher-header.component.html',
  styleUrls: ['./default-launcher-header.component.scss']
})
export class DefaultLauncherHeaderComponent implements OnDestroy {

  @Input() clockColor = '#FFF';
  @Input() logoPosition = 'center';
  @Input() clockId = 'header';

  public date = new Date();
  public isLoadingLanguage = false;
  private subscriptions = [];

  constructor(private messenger: MessengerService) {
    this.subscriptions.push(this.messenger.$currentLanguage.subscribe(lang => {
      this.isLoadingLanguage = true;
      setTimeout(() => {
        this.isLoadingLanguage = false;
      }, 10);
    }));
    IntervalService.set('header-date', () => {
      this.date = new Date();
    }, 1000);
  }

  ngOnDestroy() {
    IntervalService.clear('header-date');
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions.length = 0;
  }
}
